import controller from './product-list.controller';
import template from './product-list.template.html';
import './product-list.scss';

export default {
  controller,
  template,
};



// WEBPACK FOOTER //
// ./src/app/product/product-list/product-list.component.js